export default "__VITE_ASSET__DggI7vzD__"